export const Rules = () => {
  return (
    <section className="race-rules">
      <h2>Race Rules</h2>
      <ol>
        <li>
          Be present at all 10 Taco Bell stops along the courses. Zero tolerance
          for course cutting.
        </li>
        <li>Eat a menu item from at least 9 of the 10 Taco Bell stops.</li>
        <li>
          By the 4th stop, all entrants must have consumed at least one (1)
          Chalupa Supreme or one Crunchwrap Supreme (dietary restrictions will
          be allowed within reason).
        </li>
        <li>
          By the 8th stop, all entrants must have consumed at least one (1)
          Burrito Supreme or one Nachos Bell Grande (dietary restrictions will
          be allowed within reason).
        </li>
        <li>Finish under 11 hours.</li>
        <li>Drinks do not count as food.</li>
        <li>
          Entrants must keep all receipts and wrappers for confirmation of
          stupidity at the end of the run.
        </li>
        <li>An off-course bathroom break will be allowed at Wash Park.</li>
        <li>
          SURVIVORS will eventually get a commemorative item after successful
          completion of the run.
        </li>
        <li>
          If you intend to participate, RSVP your statement of intent. ONCE YOU
          RSVP, YOU ARE IN. THIS IS LIKE THE GOBLET OF FIRE.
        </li>
        <li>
          No on-course Pepto, Alka Seltzer, Pepcid A/C, Mylanta will be allowed!
        </li>
        <li>
          Additional "rules" may be added, amended, or changed to promote the
          intent of this run, which is to do something completely stupid.
        </li>
        <li>Congratulations?</li>
      </ol>
      <p>
        * Diablo Challenge - lather all items with Diablo sauce and do a Diablo
        shooter at the end.
      </p>
      <p>
        ** Baja Blast Challenge – drink an aggregate of 2 Liters of Baja Blast
        during the run without vomiting.
      </p>
    </section>
  );
};
